import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons';

import { loadConfigs } from '../../../actions/siteConfig';

function Banner({ deadline }) {
  const { hra = {} } = useSelector(store => store.quote);
  const [submitted, setSubmitted] = useState(false);
  const [submitDate, setSubmitDate] = useState('');

  useEffect(() => {
    // Handle nullable quote.hra objects
    /* eslint-disable camelcase */
    if (hra) {
      const { submitted_flag, submit_date } = hra;
      setSubmitted(submitted_flag);
      setSubmitDate(submit_date);
    }
  }, [hra]);

  return submitted ? (
    <div className="alert alert-success shadow-sm my-4">
      <FontAwesomeIcon
        size="xl"
        className="me-3 text-success"
        icon={faFileInvoiceDollar}
      />
      HRA submitted at {moment(submitDate).format('MM/DD/YYYY h:mma')}
    </div>
  ) : (
    <div className="alert alert-warning shadow-sm my-4">
      <FontAwesomeIcon
        size="xl"
        className="me-2"
        icon={faFileInvoiceDollar}
        color="#D19D24"
      />
      {deadline}
    </div>
  );
}

function HRAReminder() {
  const { carrier } = useSelector(store => store.quote);

  // note(joeysapp): Old method of using theme to conditionally display HRAs
  // const { hraCarriers = {} } = useSelector(store => store.theme);
  // const validCarriers = Object.keys(hraCarriers);
  // const validYears = hraCarriers[carrier] || [];
  // const displayHra = validCarriers.includes(carrier) && validYears.includes(planYear);

  const [displayHRA, setDisplayHRA] = useState(false);
  const [deadline, setDeadline] = useState('');
  useEffect(() => {
    loadConfigs('hra_form_agent_category')
      .then((configs) => {
        const formattedCarrierName = carrier.toLowerCase().replaceAll(' ', '-');
        const configKey = `hra_form_agent_${formattedCarrierName}_json`;
        if (configKey in configs) {
          const { timeToSubmitDescription, disabled } = configs[configKey];
          if (!disabled) {
            setDeadline(timeToSubmitDescription);
            setDisplayHRA(true);
          }
        }
      });
  }, []);

  return displayHRA ? <Banner deadline={deadline} /> : null;
}

export default HRAReminder;
